import ImageResizeWorker from 'worker-loader?filename=static/js/[name].js!../../workers/resizeImg.worker';
import uuid from 'react-uuid';

class ImageResizer {
  private worker: ImageResizeWorker = new ImageResizeWorker();
  private onSuccessMap: Map<string, (buf: any) => void> = new Map();
  constructor() {
    this.worker.onmessage = (e) => this.onMessageFromWorker(e);
  }

  onMessageFromWorker(event: any) {
    const taskId = event?.data?.taskId;
    const imgSrc = event?.data?.imgSrc;
    if (taskId && imgSrc) {
      this.onSuccessMap.get(taskId)?.(imgSrc);
      this.onSuccessMap.delete(taskId);
    }
  }

  resize(imgSrc: string, width: number, height: number, onSuccess: (buf: any) => void) {
    const taskId = uuid().replaceAll('-', '');
    this.onSuccessMap.set(taskId, onSuccess);
    this.worker.postMessage({
      imgSrc: imgSrc,
      width: width,
      height: height,
      taskId: taskId,
    });
  }
}

const imageResizer = new ImageResizer();

export { imageResizer };
